import { type FC } from 'react';

import { QueryState } from '@/api/components/QueryState';
import { usePortfolioGroupEsgQuery } from '@/api/esg/esgApi';
import { Esg } from '@/api/esg/models/Esg';
import { isNotReady } from '@/api/utils/isNotReady';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';

interface Props {
  portfolioGroupId: string;
  render: (data: Esg) => React.ReactNode;
}

export const WithPortfolioGroupEsgData: FC<Props> = ({
  portfolioGroupId,
  render,
}) => {
  const esgQuery = usePortfolioGroupEsgQuery({ portfolioGroupId });
  const texts = useTexts();

  if (isNotReady(esgQuery)) {
    return (
      <WithGap>
        <h2>{texts.dashboard.widgets.esgOverview.title}</h2>
        <QueryState
          query={esgQuery}
          customTexts={{ noData: { description: texts.pages.esg.noData } }}
        />
      </WithGap>
    );
  }

  return <>{render(esgQuery.data!)}</>;
};
